import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./floor-detail-home.module.scss";
import PinnedList from "../pinned-list";
import PinnedListHeader from "../pinned-list-header";
import VelavuTabSwitcher from "../../../../elements/velavu-tab-switcher";
import { FloorDetailInfo } from "./floor-detail-info";
import FloorDetailImage from "./floor-detail-image";
import FloorDetailDraw from "./floor-detail-draw";
import {
	FloorEditDataState,
	FloorEditState,
	FloorEditStateMode,
} from "../../../../state/floor/floor-edit-state";
import { useVelavuModal } from "../../../../elements/velavu-modal";
import VelavuAlertModal from "../../../../elements/velavu-alert-modal/velavu-alert-modal";
import VelavuAlertModalTitle from "../../../../elements/velavu-alert-modal/velavu-alert-modal-title";
import VelavuAlertModalContent from "../../../../elements/velavu-alert-modal/velavu-alert-modal-content";
import VelavuButton from "../../../../elements/velavu-button";
import VelavuAlertModalActions from "../../../../elements/velavu-alert-modal/velavu-alert-modal-actions";
import useDiscardModal from "./use-discard-modal";

export interface FloorDetailHomeProps {
	state: FloorEditState;
}

export default function FloorDetailHome(props: FloorDetailHomeProps) {
	const { t } = useTranslation();
	const propsSwitchMode = props.state.switchMode;
	const isDirty =
		props.state.dataState === FloorEditDataState.Dirty ||
		props.state.dataState === FloorEditDataState.Saving;

	const pushDiscardModal = useDiscardModal();
	const trySwitchMode = useCallback(
		async (mode: FloorEditStateMode) => {
			if (isDirty) {
				if (await pushDiscardModal()) {
					propsSwitchMode(mode);
				}
			} else {
				propsSwitchMode(mode);
			}
		},
		[isDirty, pushDiscardModal, propsSwitchMode],
	);

	const propsClose = props.state.close;
	const tryClose = useCallback(async () => {
		if (isDirty) {
			if (await pushDiscardModal()) {
				propsClose();
			}
		} else {
			propsClose();
		}
	}, [isDirty, pushDiscardModal, propsClose]);

	return (
		<PinnedList>
			<PinnedListHeader
				label={t("dashboard.floor_detail.edit_header")}
				onClose={tryClose}
			/>

			<VelavuTabSwitcher
				className={styles.tabSwitcher}
				selectedKey={props.state.mode}
				onSelectKey={trySwitchMode}
				labels={{
					[FloorEditStateMode.Info]: t("dashboard.tabs.info"),
					[FloorEditStateMode.Image]: t("dashboard.tabs.image"),
					[FloorEditStateMode.Draw]: t("dashboard.tabs.draw"),
				}}
			>
				{props.state.mode === FloorEditStateMode.Info && (
					<FloorDetailInfo state={props.state} />
				)}

				{props.state.mode === FloorEditStateMode.Image && (
					<FloorDetailImage state={props.state} />
				)}

				{props.state.mode === FloorEditStateMode.Draw && (
					<FloorDetailDraw state={props.state} />
				)}
			</VelavuTabSwitcher>
		</PinnedList>
	);
}
